const clinicalPresentationItems = [
  [
    ["I", "II", "III", "IV"],
    "nyhafunctionalclass",
    0,
    3,
    "NYHA Functional Class",
    "",
    ""
  ],
  [
    [],
    "heightincm",
    0,
    0,
    "Height (cm)",
    "",
    ""
  ],
  [
    [],
    "weightinkg",
    0,
    0,
    "Weight (kg)",
    "",
    ""
  ],
  [
    [],
    "bmiinkgmperm2",
    0,
    1,
    "BMI (kg/m2)",
    "",
    ""
  ],
  [
    [],
    "systolicbp",
    0,
    300,
    "Systolic blood pressure (mmHg)",
    "",
    ""
  ],
  [
    [],
    "diastolicbp",
    0,
    300,
    "Diastolic blood pressure (mmHg)",
    "",
    ""
  ],
  [
    [],
    "pulse",
    0,
    300,
    "Pulse (bpm)",
    "",
    ""
  ],
  [
    [],
    "respiratoryrate",
    0,
    150,
    "Respiratory Rate (cpm)",
    "",
    ""
  ],
  [
    [],
    "saturation",
    0,
    150,
    "Saturation (%)",
    "",
    ""
  ],
  [
    [
      "Effort dyspnoea", "Orthopnoea", "Paroxysmal nocturnal", "Fatigue", "Oedema", "Raised IVP",
      "Pulmonary Oedema", "Third heart sound", "Hepatojugular reflux", "Cardiac",
      "Laterally displaced apical impulse", "Hepatomegaly"
    ],
    "symptomsandsignsofheartfailure",
    0,
    150,
    "Symptoms and signs of heart failure",
    "",
    ""
  ],
]

const cxrItems = [
  [
    [],
    "dateobtained",
    0,
    4,
    "Date obtained",
    "",
    ""
  ],
  [
    [
      "Increased cardiothoracic ratio (0)", "Alveolar oedema (1)", "Interstitial oedema (2)",
      "Kerley B lines (3)", "Pleural Effusion (4)"
    ],
    "signsofheartfailure",
    0,
    4,
    "Signs of heart failure",
    "",
    ""
  ]
];

const leadsOptions = [
  "Inferior leads",
  "Anterior leads",
  "Lateral leads"
];

const ecgItems = [
  [
    [],
    "dateandtimeobtained",
    0,
    0,
    "Date and time obtained",
    "",
    ""
  ],
  [
    [],
    "qrsrate",
    0,
    200,
    "QRS rate",
    "",
    ""
  ],
  [
    [],
    "printerval",
    0,
    200,
    "PR interval",
    "",
    ""
  ],
  [
    [],
    "qrswidth",
    0,
    200,
    "QRS width",
    "",
    ""
  ],
  [
    [],
    "qtinterval",
    0,
    200,
    "QT interval (uncorrected QT interval)",
    "",
    ""
  ],
  [
    [
      "Sinus", "Atrial fibrillation", "Atrial flutter", "2nd degree AVB",
      "3rd degree AVB", "Ventricular tachycardia", "Other"
    ],
    "rhythm",
    0,
    6,
    "Rhythm",
    "",
    ""
  ],
  [
    [
      "By Sokolow-Lyon (S in V1 + R in V5 or V6 > 35mm)",
      "Cornell Criteria (S in V3 + R in aVL > 28 in male or 22 in females)",
      "R > 11mm in I",
      "R > 11mm in aVL"
    ],
    "lvh",
    0,
    3,
    "LVH",
    "",
    ""
  ],
  [
    [
      "Inferior leads",
      "Anterior leads",
      "Lateral leads"
    ],
    "qwaves",
    0,
    2,
    "Q waves (deeper than 2mm, wider than 1mm)",
    "",
    ""
  ],
  [
    leadsOptions,
    "twaveinversion",
    0,
    2,
    "T wave inversion",
    "",
    ""
  ],
  [
    leadsOptions,
    "stelevation",
    0,
    2,
    "ST elevation",
    "",
    ""
  ],
  [
    leadsOptions,
    "stdepression",
    0,
    2,
    "ST depression",
    "",
    ""
  ]
];

const severityOptions = [
  "None", "Mild", "Moderate", "Severe"
];

const echoItems = [
  [
    [],
    "heartrateattimeofecho",
    0,
    0,
    "Heart rate at time of echo",
    "",
    ""
  ],
  [
    [],
    "lvedd",
    0,
    0,
    "LVEDD (mm)",
    "",
    ""
  ],
  [
    [],
    "lvesd",
    0,
    0,
    "LVESD (mm)",
    "",
    ""
  ],
  [
    [],
    "ivsd",
    0,
    0,
    "IVSd (mm)",
    "",
    ""
  ],
  [
    [],
    "lvpwd",
    0,
    0,
    "LVPWd (mm)",
    "",
    ""
  ],
  [
    [],
    "lvejectionfraction",
    0,
    0,
    "Left ventricular ejection fraction (%)",
    "",
    ""
  ],
  [
    severityOptions,
    "aorticstenosis",
    0,
    3,
    "Aortic Stenosis",
    "",
    ""
  ],
  [
    severityOptions,
    "aorticregurgitation",
    0,
    3,
    "Aortic Regurgitation",
    "",
    ""
  ],
  [
    severityOptions,
    "mitralstenosis",
    0,
    3,
    "Mitral stenosis",
    "",
    ""
  ],
  [
    severityOptions,
    "mitralregurgitation",
    0,
    3,
    "Mitral regurgitation",
    "",
    ""
  ],
  [
    severityOptions,
    "tricuspidregurgitation",
    0,
    3,
    "Tricuspid regurgitation",
    "",
    ""
  ],
  [
    ["Congenital", "Rheumatic", "Degenerative"],
    "aetiologyofvhd",
    0,
    0,
    "Aetiology of VHD",
    "",
    ""
  ],
  [
    [],
    "tapse",
    0,
    0,
    "TAPSE (mm)",
    "",
    ""
  ],
  [
    [],
    "rvswave",
    0,
    0,
    "RVS wave (m/s)",
    "",
    ""
  ],
  [
    severityOptions,
    "rightventriculardysfunction",
    0,
    3,
    "Right ventricular dysfunction",
    "",
    ""
  ],
  [
    [],
    "ewave",
    0,
    0,
    "E wave (m/s)",
    "",
    ""
  ],
  [
    [],
    "awave",
    0,
    0,
    "A wave (m/s)",
    "",
    ""
  ],
  [
    [],
    "earatio",
    0,
    0,
    "E/A ratio",
    "",
    ""
  ],
  [
    [],
    "laterale2",
    0,
    0,
    "Lateral e^2 (m/s)",
    "",
    ""
  ],
  [
    [],
    "septale2",
    0,
    0,
    "Septal e^2 (m/s)",
    "",
    ""
  ],
  [
    [],
    "ee2",
    0,
    0,
    "E/e^2",
    "",
    ""
  ],
  [
    [],
    "leftatrialdiameter",
    0,
    0,
    "Left atrial diameter (mm)",
    "",
    ""
  ],
  [
    [],
    "aortadiameter",
    0,
    0,
    "Aorta diameter",
    "",
    ""
  ],
  [
    [],
    "leftatrialarea",
    0,
    0,
    "Left atrial area",
    "",
    ""
  ],
  [
    [],
    "leftatrialvolume",
    0,
    0,
    "Left atrial volume",
    "",
    ""
  ],
  [
    [],
    "tricuspidregurgitationvmax",
    0,
    0,
    "Tricuspid regurgiation max velocity (m/s)",
    "",
    ""
  ],
  [
    [],
    "peakgradient",
    0,
    0,
    "Peak gradient (mmHg)",
    "",
    ""
  ],
  [
    [],
    "ivcdiameteronexpiration",
    0,
    0,
    "IVC diameter on expiration",
    "",
    ""
  ],
  [
    [],
    "ivcdiametteroninspiration",
    0,
    0,
    "IVC diameter on inspiration",
    "",
    ""
  ],
  [
    [
      "Yes",
      "No"
    ],
    "greaterthan50percentcollapseoninspiration",
    0,
    1,
    ">50% collapse on inspiration",
    "",
    ""
  ],
  [
    [],
    "estimatedpulmonaryarterysystolicpressure",
    0,
    0,
    "Estimated pulmonary artery systolic pressure (mmHg)",
    "",
    ""
  ],
  [
    severityOptions,
    "pericardialeffusion",
    0,
    3,
    "Pericardial Effusion",
    "",
    ""
  ]
];

const biochemist = [
  "Na", "K", "Urea/BUN", "Creatinine", "TSH", "Fe",
  "Transferrin", "Ferritin", "Total Cholesterol", "TG",
  "HDL", "LDL", "NT-proBNP", "BNP", "Troponin I",
  "Troponin T", "CK", "CKMB", "Glucose", "AST", "ALT",
  "Total Bilirubin", "WCC", "Hb", "MCV", "Platelets"
];

const biochemistryItems = [
  [ "na", "Na (mmol/l)" ],
  [ "k", "K (mmol/l)" ],
  [ "ureabun", "Urea/BUN" ],
  [ "creatinine", "Creatinine" ],
  [ "tsh", "TSH" ],
  [ "fe", "Fe" ],
  [ "transferrin", "Transferrin" ],
  [ "ferritin", "Ferritin" ],
  [ "total_cholesterol", "Total Cholesterol" ],
  [ "triglycerides", "Triglycerides" ],
  [ "hdl", "HDL" ],
  [ "ck", "CK" ],
  [ "ckmb", "CK-MB" ],
  [ "glucose", "Glucose" ],
  [ "ast", "AST" ],
  [ "alt", "ALT" ],
  [ "totalbilirubin", "Total Bilirubin" ],
  [ "wcc", "WCC" ],
  [ "hb", "Hb" ],
  [ "mcv", "MCV" ],
  [ "platelet", "Platelets" ]
].map(([c, v]) => [[], c, 0, 200, v, "", ""]);

const biochem = [
  [
    [],
    "na",
    0,
    200,
    "Na (mmol/l)",
    "",
    ""
  ],
  [
    [],
    "k",
    0,
    200,
    "K (mmol/l)",
    "",
    ""
  ],
  [
    [],
    "ureabun",
    0,
    200,
    "Urea/BUN",
    "",
    ""
  ],
  [
    [],
    "creatinine",
    0,
    200,
    "Creatinine",
    "",
    ""
  ],
  [
    [],
    "tsh",
    0,
    200,
    "TSH",
    "",
    ""
  ],
  [
    [],
    "fe",
    0,
    200,
    "Fe",
    "",
    ""
  ],
  [
    [],
    "transferrin",
    0,
    200,
    "Transferrin",
    "",
    ""
  ],
  [
    [],
    "ferritin",
    0,
    200,
    "Ferritin",
    "",
    ""
  ]
];

export const cardioItems = [
  [ "Clinical Presentation", clinicalPresentationItems ],
  [ "Chest X-Ray", cxrItems ],
  [ "ECG", ecgItems ],
  [ "Echocardiography", echoItems ],
  [ "Biochemistry", biochemistryItems ]
];
